"use strict";

module.exports.componentState = function (component, urlGetter, mementoGetter) {
    if (component.isActive()) {
        return {
            memento: mementoGetter(),
            url: urlGetter(),
        };
    } else {
        return {
            memento: "disabled",
            url: {},
        };
    }
};
